import {Branch} from '../interfaces/branch.interface';
import {branchHviezdoslavova} from './branch-hviezdoslavova.const';
import {branchKomenskeho} from './branch-komenskeho.const';

export const branches: Branch[] = [
  branchHviezdoslavova,
  branchKomenskeho,
];
